export default __webpack_public_path__ + "static/media/background2.0450c713.webp";